import { createSlice } from '@reduxjs/toolkit'

import { getRouterState } from 'src/lib/util/router'

import * as reducers from './reducers'

export const initialState = getRouterState()

const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers
})

export default routerSlice
